/**
 * Beyond 20 — tabletop RPG roller bridging D&D Beyond to Roll20 / Foundry
 *
 * Declares a single WAR group matched to all http(s) origins with no `use_dynamic_url`,
 * covering `images/*`, several `libs/` scripts and stylesheets, the dist roll scripts and
 * `popup.html`. Every path is static, so each is reachable from any page at a fixed URL.
 *
 * `images/discord-logo.png` is the cleanest signal: being an image it loads through
 * `probeImage` with no CORS grant, and `libs/css/alertify-themes/beyond20.css` carries a
 * vendor-named path that corroborates it.
 *
 * Manifest verified against version 2.20.1.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'gnblbpbepfbfmoobegdogkglpbhcjofh';

export const beyond20: ExtensionDefinition = {
  id: ID,
  name: 'Beyond 20',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 500_000,
  notes:
    'Static images, libs and popup exposed to all http(s) origins, no dynamic URL. The ' +
    'image load is conclusive; the beyond20 theme CSS corroborates.',
  signals: [
    {
      id: 'war-discord-logo-image',
      kind: 'web-accessible-resource',
      description:
        'Load images/discord-logo.png via <img> — a static image exposed to http(s) ' +
        'origins; needs no CORS grant, so it works under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/discord-logo.png'),
    },
    {
      id: 'war-beyond20-theme-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch libs/css/alertify-themes/beyond20.css — a vendor-named stylesheet, ' +
        'distinctive to this extension.',
      weight: 0.5,
      run: () => probeFetch(ID, 'libs/css/alertify-themes/beyond20.css'),
    },
    {
      id: 'war-popup-html',
      kind: 'web-accessible-resource',
      description: 'Fetch popup.html — the popup page, an independent third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'popup.html'),
    },
  ],
};
